export default __webpack_public_path__ + "static/media/tut8.c747a715.png";